export class Loaddata{

    public static filterData;
    public static MemberHistory(){
        
    }
}